
import { Stack } from '@fluentui/react/lib/Stack';
import { RootState } from 'app/store';
import CustomPanel from 'components/controls/CustomPanel';
import SimpleCard from 'components/controls/SimpleCard';
import {EViewType, styleSummary} from 'global/Application';
import { IComponentContextMenu } from 'model/Application';
import {
    IBenefit as FAM_IBenefit,
    IFeesAndPremiums as FAM_IFeesAndPremiums,
    IPlan as FAM_IPlan
} from "model/FlexibleAttributeModel";
import React, { ChangeEvent, useMemo } from "react";
import {connect, ConnectedProps, useDispatch, useSelector} from 'react-redux';
import OptionControl from "../../components/controls/OptionControl";
import { changeMergeSnap } from "../../global/Reducer/compSlice";
import {
    bcbs_config_category as IXrmTypes_bcbs_config_category
} from "../../model/CRM";
import ComparisonAttributeSetGridView from "./ComparisonAttributeSetGridView";
import FlexibleFieldView from './ComparisonFlexibleFieldView';
import {Text} from "@fluentui/react";
import { $cat_$plan_id } from "model/ConfigCategoryConstants";


interface IPlan extends TComponentConnectedProps, IComponentContextMenu {
    plan?: FAM_IPlan;
    benefits?: FAM_IBenefit[];
    feesAndPremiums?:FAM_IFeesAndPremiums[];
    merge: boolean;
    leftright: boolean;
    counter: number;
    noDiff: () => void;
    noDifference: Record<string, boolean>;
}

const Plan = (props: IPlan) => {
    const state = useSelector((state: RootState) => state);
    const disabled = state.status.viewType !== EViewType.Modify;

    const [noDifference, setNoDifference] = React.useState<Record<string, boolean>>({"default":true});
    const buttonStyles: any = {root: {paddingRight: '10px', paddingLeft: '10px', marginLeft: '5px'}};

    const dispatch = useDispatch();

    const plan: FAM_IPlan = props.plan!;
    const benefits: FAM_IBenefit[] = props.benefits!;
    const feesAndPremium: FAM_IFeesAndPremiums[] = props.feesAndPremiums!;
    const defaultCollapsed : boolean = !state.status.expandAllPanels;
    const categoryPlan = useMemo(() => {
        return state.data.config?.cache?.map_bcbs_config_category[$cat_$plan_id];
    }, [state.data.config]);


    return (
        <>
            <CustomPanel title={"Properties"} canCollapse={true} defaultCollapsed={defaultCollapsed} contentStyle={{overflow: 'visible'}} storageId={"plan.properties"}>
                <Stack
                    horizontal
                    wrap
                    verticalFill
                    tokens={{ childrenGap: 15 }}
                    horizontalAlign="start"
                    style={{ padding: '15px' }}
                >
                    {(state.comp.leftSnap.json?.plans?.filter(a => !a.deactivated).find(p => p.name === plan.name || p.id === plan.id)?.grandFathered?.name !== state.comp.rightSnap.json?.plans?.filter(a => !a.deactivated).find(p => p.name === plan.name || p.id === plan.id)?.grandFathered?.name || state.status.displayAll) &&
                    <><div style={{width:'40%'}}>
                        <dl style={styleSummary.dl}><dt style={styleSummary.dt}><Text styles={{ root: { fontWeight: '680' } }}>Grandfathered</Text></dt>
                            <dd style={styleSummary.dd}><Text>{state.comp.leftSnap.json?.plans?.filter(a => !a.deactivated).find(p => p.name === plan.name || p.id === plan.id)?.grandFathered?.name ?? 'No Value'}</Text></dd></dl>
                    </div>
                    <div style={{width:'40%'}}>   <dl style={styleSummary.dl}><dt style={styleSummary.dt}><Text styles={{ root: { fontWeight: '680' } }}>Grandfathered</Text></dt>
                        <dd style={styleSummary.dd}><Text>{state.comp.rightSnap.json?.plans?.filter(a => !a.deactivated).find(p => p.name === plan.name || p.id === plan.id)?.grandFathered?.name ?? 'No Value'}</Text></dd></dl>
                    </div>
                        </>}

                    {(state.comp.leftSnap.json?.plans?.filter(a => !a.deactivated).find(p => p.name === plan.name || p.id === plan.id)?.fundingType?.name !== state.comp.rightSnap.json?.plans?.filter(a => !a.deactivated).find(p => p.name === plan.name || p.id === plan.id)?.fundingType?.name || state.status.displayAll) &&
                        <><div style={{width:'40%'}}>
                            <dl style={styleSummary.dl}><dt style={styleSummary.dt}><Text styles={{ root: { fontWeight: '680' } }}>Funding Type</Text></dt>
                                <dd style={styleSummary.dd}><Text>{state.comp.leftSnap.json?.plans?.filter(a => !a.deactivated).find(p => p.name === plan.name || p.id === plan.id)?.fundingType?.name ?? 'No Value'}</Text></dd></dl>
                        </div>
                            <div style={{width:'40%'}}>   <dl style={styleSummary.dl}><dt style={styleSummary.dt}><Text styles={{ root: { fontWeight: '680' } }}>Funding Type</Text></dt>
                                <dd style={styleSummary.dd}><Text>{state.comp.rightSnap.json?.plans?.filter(a => !a.deactivated).find(p => p.name === plan.name || p.id === plan.id)?.fundingType?.name ?? 'No Value'}</Text></dd></dl>
                            </div>
                        </>}
                </Stack>
            </CustomPanel>
            <CustomPanel title={"Benefits"}
                canCollapse={true}
                defaultCollapsed={defaultCollapsed}
                contentStyle={{ overflow: 'visible' }}
                storageId={"plan.benefits"}
            >
                <Stack
                    horizontal
                    wrap
                    verticalFill
                    tokens={{ childrenGap: 15 }}
                    horizontalAlign="start"
                    style={{ padding: '15px' }}
                >

                    {benefits?.filter(a => !a.deactivated).filter(b => state.comp.leftSnap.json?.plans?.filter(a => !a.deactivated).find(p => p.name === plan.name || p.id === plan.id)?.benefitRefs?.some(br => br?.id === b?.id) || state.comp.rightSnap.json?.plans?.filter(a => !a.deactivated).find(p2 => p2.name === plan.name || p2.id === plan.id)?.benefitRefs?.some(br2 => br2?.id === b?.id)).map(benefit => {

                        let change = !props.noDifference[benefit.id];
                        if(change && state.comp.leftSnap.json?.plans && state.comp.rightSnap.json?.plans){
                            let ben1 = JSON.stringify(state.comp.leftSnap.json?.benefits?.filter(a => !a.deactivated).find(br => br?.id === benefit?.id));
                            let ben2 = JSON.stringify(state.comp.rightSnap.json?.benefits?.filter(a => !a.deactivated).find(br => br?.id === benefit?.id));
                            change = ben1 !== ben2;
                        }
                        return (
                        !(state.comp.leftSnap.json?.plans?.filter(a => !a.deactivated).find(p => p.name === plan.name || p.id === plan.id)?.benefitRefs.some(br=> br?.id === benefit.id) === state.comp.rightSnap.json?.plans?.filter(a => !a.deactivated).find(p => p.name === plan.name || p.id === plan.id)?.benefitRefs.some(br=> br?.id === benefit.id)) ?

                            <SimpleCard
                            key={benefit.id}
                            description={benefit.name}
                            change={true}
                            comparison={true}
                            onClick={() => {
                                const view = document.getElementById(benefit.id);
                                if (view) {
                                    view.scrollIntoView({behavior: 'smooth'});
                                }
                            }}

                            header={benefit.bcbs_name}
                            changeText={state.comp.rightSnap.json?.plans?.filter(a => !a.deactivated).find(p => p.name === plan.name)?.benefitRefs?.some(b => b.id === benefit.id) ? 'Only on Right': 'Only on Left'}
                        /> :
                            (state.status.displayAll || change) &&
                            <SimpleCard onClick={() => {
                                const view = document.getElementById(benefit.id);
                                if (view) {
                                    view.scrollIntoView({behavior: 'smooth'});
                                }
                            }}
                                key={benefit.id}
                                change={change}
                                        changeText={change? 'Has Changes' : ''}
                                        header={benefit.bcbs_name}
                                description={benefit.name}
                                comparison={true}
                           />
                        )

                    })}
                </Stack>
            </CustomPanel>
            <CustomPanel title={"Attributes"}
                canCollapse={true}
                defaultCollapsed={defaultCollapsed && state.status.panelStatus[`compare.plan.attributes.${plan.id}`]}
                contentStyle={{ overflow: 'visible' }}
                storageId={`compare.plan.attributes.${plan.id}`}
            >
                <FlexibleFieldView
                    disabled={disabled}
                    fields={state.comp.leftSnap.json?.plans?.filter(a => !a.deactivated).find(p => p.name === plan.name)?.fields}
                    tiers={[]}
                    category={categoryPlan}
                    scope={plan}
                    fields2={state.comp.rightSnap.json?.plans?.filter(a => !a.deactivated).find(p => p.name === plan.name)?.fields}
                    mergeFields={state.comp.mergeSnap.json?.plans?.filter(a => !a.deactivated).find(p => p.name === plan.name)?.fields}
                    merge={props.merge}
                    leftright={props.leftright}
                    compare={!state.status.displayAll}
                    isApproval={state.router.location.pathname.indexOf('underwriting') > -1}
                    locationId={state.comp.rightSnap.json?.plans?.filter(a => !a.deactivated).find(p => p.name === plan.name)?.id}
                    noDiff={() => {
                        if(!noDifference[plan.id]) {
                            setNoDifference((prevState) => {
                                return {...prevState, [plan.id]: true}
                            })
                        }
                        props.noDiff();
                    }}
                />
            </CustomPanel>

            <CustomPanel title={"Group Numbers"}
                canCollapse={true}
                defaultCollapsed={defaultCollapsed}
                storageId={"plan.groupNumbers"}
                contentStyle={{ overflow: 'visible' }}
            >
                <div style={{ padding: '8px' }}></div>
                {(state.comp.leftSnap?.json?.groupStructure?.groupNumbers.filter(a => !a.deactivated) || state.comp.rightSnap?.json?.groupStructure?.groupNumbers.filter(a => !a.deactivated)) &&
                    <ComparisonAttributeSetGridView
                        label={"Group Number"}
                        category = {state.data.config.cache.map_bcbs_config_category_named["Group Number"].bcbs_config_categoryid as IXrmTypes_bcbs_config_category}
                        snap={state.comp.leftSnap?.json}
                        snap2={state.comp.rightSnap?.json}
                        mergeSnap={state.comp.mergeSnap?.json}
                        compare={!state.status.displayAll}
                        comparison
                        leftright={props.leftright}
                        counter={props.counter}
                        scope={plan}
                        merge={props.merge}
                        tierNames={null}
                    />
                }
            </CustomPanel>
            <CustomPanel title={"Fees And Premiums"}
                storageId={"plan.feesAndPremiums"}
                canCollapse={true}
                defaultCollapsed={defaultCollapsed}
                contentStyle={{ overflow: 'visible' }}
                         items={props.merge? [{
                             key: 'mergeToggle',
                             onClick: (event:  ChangeEvent<HTMLInputElement>, item: any) => {
                                 if (event?.stopPropagation)
                                     event.stopPropagation();
                             },
                             onRender: () => {
                                 return  <OptionControl
                                     styles={buttonStyles}
                                     label="Set all fields inside this panel to"
                                     options={[
                                         { key: 'No', text: 'Left', data: { type: 'bool', value: false } },
                                         { key: 'Yes', text: 'Right', data: { type: 'bool', value: true } },
                                     ]}
                                     unclick={true}
                                     fieldValueOnChange={(event, selected) => {
                                         let temp;
                                         if(selected.value){
                                             temp = {...plan, feesAndPremiumsRef: state.comp.rightSnap?.json?.plans?.find(p => p.name === plan.name)?.feesAndPremiumsRef ?? null}
                                         }
                                         else {
                                             temp = {...plan, feesAndPremiumsRef: state.comp.leftSnap?.json?.plans?.find(p => p.name === plan.name)?.feesAndPremiumsRef ?? null}
                                         }
                                         dispatch(changeMergeSnap({...state.comp.mergeSnap, json: {...state.comp.mergeSnap.json, plans: [...state.comp.mergeSnap.json?.plans.filter((p) => p.name !== plan.name), temp]}}));

                                         if (event?.stopPropagation)
                                             event.stopPropagation();
                                     }}
                                 />;
                             },
                         }] : []}
            >
                <Stack
                    horizontal
                    wrap
                    verticalFill
                    tokens={{ childrenGap: 15 }}
                    horizontalAlign="start"
                    style={{ padding: '15px' }}
                >
                    {state.comp.leftSnap.json?.plans?.find(p => p.name === plan.name && !p.deactivated)?.feesAndPremiumsRef?.id !== state.comp.rightSnap.json?.plans?.filter(a => !a.deactivated).find(p => p.name === plan.name && !p.deactivated)?.feesAndPremiumsRef?.id ?
                    feesAndPremium?.filter(a => !a.deactivated).filter(b => state.comp.leftSnap.json?.plans?.filter(a => !a.deactivated).find(p => p.name === plan.name)?.feesAndPremiumsRef?.id === b?.id
                    || state.comp.rightSnap.json?.plans?.filter(a => !a.deactivated).find(p => p.name === plan.name)?.feesAndPremiumsRef?.id === b?.id)?.map(fee => {
                        return (
                            <SimpleCard
                                key={fee?.id}
                                description={fee?.name}
                                comparison={true}
                                change={true}
                                changeText={state.comp.rightSnap.json?.plans?.filter(a => !a.deactivated).find(p => p.name === plan.name)?.feesAndPremiumsRef?.id === fee?.id ? 'Only on Right' : 'Only on Left'}
                            />
                        )
                    }) :
                    state.status.displayAll && feesAndPremium?.filter(a => !a.deactivated).filter(f => f?.id === state.comp.rightSnap.json?.plans?.filter(a => !a.deactivated).find(p => p.name === plan.name)?.feesAndPremiumsRef?.id)?.map(fee => {
                        debugger
                            return (
                                <SimpleCard
                                    key={fee?.id}
                                    description={fee?.name}
                                    comparison={true}
                                />
                            )
                        })
                    }
                </Stack>
            </CustomPanel>
        </>
    );
}


function mapStateToProps(state: RootState) { return { state } }
const connector = connect(mapStateToProps);
type TComponentConnectedProps = ConnectedProps<typeof connector>;
export default connect(mapStateToProps)(Plan)